import CREApi from './_creApi';
import httpClient from '@/apis/base/httpclient';
class CRERepExportListAPI extends CREApi {
  constructor() {
    super();
  }
  controllerName = 'CRERepExportLists';

  /**
   * Dữ liệu xuất khẩu báo cáo
   */
  getDataExportReport(param) {
    let request = {
      url: this.getAPIUrl() + '/ExportFinancialReport',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Dữ liệu xuất khẩu báo cáo
   */
  export(param) {
    let request = {
      url: this.getAPIUrl() + '/Export',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Lấy thông tin từ file TKT nếu có
   */
  /**
   * Kiểm tra trạng thái nhiều hồ sơ thanh toán
   */
  async getTKTInfo() {
    let request = {
      url: this.getAPIUrl() + '/TKTInfo',
    };

    return await httpClient.getAsync(request);
  }
}

export default new CRERepExportListAPI();
